import React from "react";
import { Flex, type SpaceProps } from "@chakra-ui/react";

type ButtonGroupProps = {
  /**
   * The buttons in the button group.
   */
  children: React.ReactNode;
} & SpaceProps;

/**
 * Use Button group when rendering more than one button in a row.
 */
export function ButtonGroup({ children, ...spaceProps }: ButtonGroupProps) {
  return (
    <Flex maxW="100%" gap="smallest" flexWrap="wrap" {...spaceProps}>
      {children}
    </Flex>
  );
}
